import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme, transientOptions } from "shared/lib/styles";

import { ContentCoverImage } from "scmp-app/components/content/content-cover-image";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div``;

export const StyledContentCoverImage = styled(ContentCoverImage)`
  grid-area: cover-image;
`;

export const StyledEntityLink = styled(EntityLink, {
  ...transientOptions,
})<{ $hideOnMobile?: boolean }>`
  display: grid;
  grid:
    "cover-image cover-image"
    "article-index-number headline"
    / 24px 1fr;
  gap: 12px;

  ${props =>
    props.$hideOnMobile &&
    css`
      ${theme.breakpoints.down("tablet")} {
        gap: 0 12px;

        ${StyledContentCoverImage} {
          display: none;
        }
      }
    `}
`;

export const Headline = styled.div`
  grid-area: headline;

  display: flex;
  align-items: center;

  color: #000000;
  font-weight: 700;
  font-size: 15px;
  font-family: ${fontMerriweather};
  line-height: 140%;
`;

export const ArticleNumberIndex = styled.div`
  grid-area: article-index-number;

  color: #4585ff;
  font-weight: 300;
  font-size: 48px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
`;
